import { Box, Stack } from "@mui/material";
import { ClipboardLogo } from "@src/appV2/lib";
import ClipboardLogotype from "@src/appV2/lib/assets/illustrations/clipboard-logotype.svg";
import { useDoubleTap } from "@src/appV2/lib/utils";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { isRebrandingEnabled } from "@src/appV2/redesign/system/ui-theme";
import { type ReactElement } from "react";

const tagLines = ["Hundreds of shifts.", "Instant payouts.", "Great pay."];

interface AuthHeadlineProps {
  onLogoSecretTap?: () => void;
}

export function AuthLogo(props?: AuthHeadlineProps): ReactElement {
  const onLogoSecretTap = props?.onLogoSecretTap;
  const handleLogoTap = useDoubleTap(onLogoSecretTap);

  return (
    <Stack
      alignItems="center"
      sx={{
        paddingTop: isRebrandingEnabled() ? "80px" : 4,
        cursor: onLogoSecretTap ? "pointer" : "default",
      }}
      onTouchEnd={handleLogoTap}
      onClick={handleLogoTap}
    >
      {isRebrandingEnabled() ? (
        <Box sx={{ width: 180, color: (theme) => theme.palette.text.primary }}>
          <ClipboardLogotype />
        </Box>
      ) : (
        <ClipboardLogo width={200} />
      )}
    </Stack>
  );
}

export function AuthTitle(): ReactElement {
  return isRebrandingEnabled() ? (
    <Text
      variant="h3"
      textAlign="center"
      sx={{
        color: (theme) => theme.palette.text.primary,
      }}
    >
      Book shifts on
      <br />
      your schedule
    </Text>
  ) : (
    <Stack spacing={3} alignItems="center">
      {tagLines.map((tagLine) => (
        <Text
          key={tagLine}
          variant="h3"
          sx={{
            color: (theme) => theme.palette.primary.light,
          }}
        >
          {tagLine}
        </Text>
      ))}
    </Stack>
  );
}

export function AuthHeadline(props?: AuthHeadlineProps): ReactElement {
  return (
    <Stack spacing={isRebrandingEnabled() ? 8 : 2} alignItems="center" textAlign="center">
      <AuthLogo onLogoSecretTap={props?.onLogoSecretTap} />
      <AuthTitle />
    </Stack>
  );
}
